namespace SorAraBul.PropertyManagement {
    export interface TenantsForm {
        PropertyId: Serenity.ServiceLookupEditor;
        Name: Serenity.StringEditor;
        Surname: Serenity.StringEditor;
        Phone: Common.PhoneEditor;
        Email: Serenity.EmailAddressEditor;
    }

    export class TenantsForm extends Serenity.PrefixedContext {
        static formKey = 'PropertyManagement.Tenants';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TenantsForm.init)  {
                TenantsForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = Common.PhoneEditor;
                var w3 = s.EmailAddressEditor;

                Q.initFormType(TenantsForm, [
                    'PropertyId', w0,
                    'Name', w1,
                    'Surname', w1,
                    'Phone', w2,
                    'Email', w3
                ]);
            }
        }
    }
}
